// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"ed71ef48","184":"4d916743","268":"b1ac4161","579":"a4ad43ae","708":"8928e807"}[chunkId] + ".chunk.css";
};